@if (showSidebar) {
  <div>
    <ngx-guided-tour></ngx-guided-tour>
    <!-- <div class="proposal">
    <h2>View Proposals</h2>
    <p>This is the list of proposals coming from the .proposal section in sidebar.component.html</p>
  </div> -->
  <!-- ADD CLASS dsSideBar -->
  <div class="d-flex flex-column dsSideBar vh-100  bg-white" [ngClass]="{'dashboardData_show': !showDashboard, 'dashboardData_hide': showDashboard}">
    <div class="d-flex justify-content-center mt-2">
      <!-- Logo Section -->
      <a href="/" class="text-center px-2 py-2 bg-white">
        @if (!(isArtist || isGallery)) {
          <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" height="70" />
        }
        @if (isArtist && isFreePlanUser) {
          <img src="assets/images/AFP-logo-horizontal/AFP-logo-free-artists-300.png" height="70" />
        }
        @if (isArtist && !isFreePlanUser) {
          <img src="assets/images/AFP-logo-horizontal/AFP-logo-pro-artists-300.png" height="70" />
        }
        @if (isGallery && isFreePlanUser) {
          <img src="assets/images/AFP-logo-horizontal/AFP-logo-free-galleries-300.png" height="70" />
        }
        @if (isGallery && !isFreePlanUser) {
          <img src="assets/images/AFP-logo-horizontal/AFP-logo-pro-galleries-300.png" height="70" />
        }
      </a>
    </div>
    <div class="dsSideMenu flex-grow-1 mt-3 ps-3 bg-white">
      <p-menu [model]="items" styleClass="border-0 w-100" expanded="true"></p-menu>
    </div>
    <!-- ADD CLASS dsBottomLogo -->
    <!-- Logo Section (conditionally hidden) -->
    @if (authUser && !hideLogo) {
      <div class="border-top border-end dsBottomLogo"
        [ngClass]="{'bottomhide-logo': showDashboard, 'bottomshow-logo': !showDashboard}"
        >
        <div class="d-flex justify-content-center align-items-center">
          <a href="/" class="text-center px-2 py-2">
            <img [src]="(authUser.LogoUrl && authUser.LogoUrl.trim()) ? authUser.LogoUrl : 'assets/images/AFP-logo-v02-800.png'"
              (error)="$any($event.target).src='assets/images/AFP-logo-v02-800.png'"
              height="70" />
            </a>
          </div>
        </div>
      }
    </div>
  </div>
}

